import React, { useContext, useEffect, useState } from "react";
import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  InputLabel,
  Grid,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Select,
  Typography,
} from "@mui/material";
import QEStrategyCommonButton from "../qe-strategy-homepage/CommonButton";
import { QEStrategydataFlowContext } from "../../../main-pages/QEStrategyMainPage";
import { usePrefillForm } from "../../../../utils/qe-strategy-utils/usePreFillForm";

const QualityCultureGovernanceAndTestDebt = ({ onBack, onNext }) => {
  // --- State Variables ---
  const [qePriorities, setQePriorities] = useState("");
  const [qePerception, setQePerception] = useState("");
  const [qeInfluence, setQeInfluence] = useState("");
  const [feedbackLoops, setFeedbackLoops] = useState("");
  const [qualityFailures, setQualityFailures] = useState("");
  const [defectPatterns, setDefectPatterns] = useState("");
  const [prodFeedback, setProdFeedback] = useState("");
  const [qualityMetrics, setQualityMetrics] = useState("");
  const [percentageOfAutomatedTests, setPercentageOfAutomatedTests] =
    useState("");

  const {
    qualityCultureGovernanceAndTestDebt,
    setQualityCultureGovernanceAndTestDebt,
    dataFromFileUploads,
  } = useContext(QEStrategydataFlowContext);

  // --- Handlers ---

  const handleQePrioritiesChange = (e) => setQePriorities(e.target.value);
  const handleQePerceptionChange = (e) => setQePerception(e.target.value);
  const handleQeInfluenceChange = (e) => setQeInfluence(e.target.value);
  const handleFeedbackLoopsChange = (e) => setFeedbackLoops(e.target.value);
  const handleQualityFailuresChange = (e) => setQualityFailures(e.target.value);
  const handleDefectPatternsChange = (e) => setDefectPatterns(e.target.value);
  const handleProdFeedbackChange = (e) => setProdFeedback(e.target.value);
  const handleQualityMetricsChange = (e) => setQualityMetrics(e.target.value);
  const handlePercentageOfAutomatedTestsChange = (e) =>
    setPercentageOfAutomatedTests(e.target.value);

  
  useEffect(() => {
    if (qualityCultureGovernanceAndTestDebt) {
      setQePriorities(
        qualityCultureGovernanceAndTestDebt.qePriorities || ""
      );
      setQePerception(
        qualityCultureGovernanceAndTestDebt.qePerception || ""
      );
      setQeInfluence(
        qualityCultureGovernanceAndTestDebt.qeInfluence || ""
      );
      setFeedbackLoops(
        qualityCultureGovernanceAndTestDebt.feedbackLoops || ""
      );
      setQualityFailures(
        qualityCultureGovernanceAndTestDebt.qualityFailures || ""
      );
      setDefectPatterns(
        qualityCultureGovernanceAndTestDebt.defectPatterns || ""
      );
      setProdFeedback(
        qualityCultureGovernanceAndTestDebt.prodFeedback || ""
      );
      setQualityMetrics(
        qualityCultureGovernanceAndTestDebt.qualityMetrics || ""
      );
      setPercentageOfAutomatedTests(
        qualityCultureGovernanceAndTestDebt.percentageOfAutomatedTests ||
          ""
      );
    }
  }, [qualityCultureGovernanceAndTestDebt]);

  const qualityCultureGovernanceAndTestDebtDataObject = {
    qePriorities,
    qePerception,
    qeInfluence,
    feedbackLoops,
    qualityFailures,
    defectPatterns,
    prodFeedback,
    qualityMetrics,
    percentageOfAutomatedTests,
  };

  const handleBack = () => {
    onBack();
  };

  const handleNext = () => {
    setQualityCultureGovernanceAndTestDebt(
      qualityCultureGovernanceAndTestDebtDataObject
    );
    onNext();
  };

  const questionToFieldMap = {
    "1. Who defines QE priorities during release planning?": "qePriorities",
    "2. How is QE perceived?": "qePerception",
    "3. How often does QE influence release decisions?": "qeInfluence",
    "4. Are quality metrics visible in leadership dashboards or OKRs?":
      "qualityMetrics",
    "5. Are quality failures reviewed across functional teams?":
      "qualityFailures",
    "6. Are defect patterns used to improve backlog or feature design?":
      "defectPatterns",
    "7. Is production feedback mapped to automated tests?": "prodFeedback",
    "8. What % of automated tests typically require rework per release?":
      "percentageOfAutomatedTests",
    "9. Are outdated or irrelevant test scripts periodically retired?":
      "feedbackLoops",
  };

  const [qePrioritiesOptions, setQePrioritiesOptions] = useState([
    "QA/QE Lead",
    "Product Owner/Business",
    "Scrum Master/Agile Coach",
    "Cross-functional team",
  ]);

  const [qeInfluenceOptions, setQeInfluenceOptions] = useState([
    "Always",
    "Sometimes",
    "Rarely",
    "Never",
  ]);

  const [defectPatternsOptions, setDefectPatternsOptions] = useState([
    "Backlog",
    "Feature design",
    "Both",
    "None",
  ]);

  const [
    percentageOfAutomatedTestsOptions,
    setPercentageOfAutomatedTestsOptions,
  ] = useState(["0–10%", "10–20%", "20–30%", "More than 30%"]);

  usePrefillForm(
    dataFromFileUploads,
    questionToFieldMap,
    {
      qePriorities: setQePriorities,
      qePerception: setQePerception,
      qeInfluence: setQeInfluence,
      feedbackLoops: setFeedbackLoops,
      qualityFailures: setQualityFailures,
      defectPatterns: setDefectPatterns,
      prodFeedback: setProdFeedback,
      qualityMetrics: setQualityMetrics,
      percentageOfAutomatedTests: setPercentageOfAutomatedTests,
    },
    null,
    {
      qePriorities: {
        options: qePrioritiesOptions,
        setOptions: setQePrioritiesOptions,
      },
      qeInfluence: {
        options: qeInfluenceOptions,
        setOptions: setQeInfluenceOptions,
      },
      defectPatterns: {
        options: defectPatternsOptions,
        setOptions: setDefectPatternsOptions,
      },
      percentageOfAutomatedTests: {
        options: percentageOfAutomatedTestsOptions,
        setOptions: setPercentageOfAutomatedTestsOptions,
      },
    }
  );

  return (
    <Box
      sx={{
        width: {
          xs: "100%", // full width on small screens
          sm: "100%",
          md: "1030px", // fixed width on medium and above
        },
        mx: "auto", // center horizontally
        mt: { xs: 5, sm: 8, md: 3 },
        mb: { xs: 4, md: 6 },
        px: { xs: 2, sm: 3 }, // side padding only for smaller screens
      }}
    >
      <Paper
        elevation={3}
        sx={{
          p: { xs: 2, sm: 3, md: 4 },
        }}
      >
        {/* Title */}
<Typography
          variant="h6"
          sx={{
            fontSize: 20,
            mb: -1,
            position: "relative",
            top: "-20px",
          }}
        >          Quality Culture, Governance & Test Debt
        </Typography>

        <Grid container spacing={3} >
          {/* Who defines QE priorities */}
          <Grid item xs={12} >
          <FormControl fullWidth variant="outlined">
            <InputLabel
              shrink
              id="qe-priorities-label"
              sx={{
                background: "#fff",
                px: 0.5,
                mb: 0.5,
              }}
            >
              Who defines QE priorities during release planning?
            </InputLabel>
            <Select
              labelId="qe-priorities-label"
              value={qePriorities}
              onChange={handleQePrioritiesChange}
              displayEmpty
              renderValue={(selected) => {
                if (!selected) {
                  return <span style={{ color: "#aaa" }}>Select</span>;
                }
                return selected;
              }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 200, // ✅ adds scrollbar if too tall
                    width: 300,     // ✅ fixed width 300px
                  },
                },
                disablePortal: false,
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                PopperProps: {
                  modifiers: [
                    {
                      name: "flip",
                      enabled: false,
                    },
                    {
                      name: "preventOverflow",
                      enabled: true,
                      options: {
                        boundary: "viewport",
                      },
                    },
                  ],
                },
              }}
            >
              {qePrioritiesOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          </Grid>

          {/* QE perception */}
          <Grid item xs={12}>
            <FormControl>
              <FormLabel>How is QE perceived?</FormLabel>
              <RadioGroup
                row
                value={qePerception}
                onChange={handleQePerceptionChange}
              >
                <FormControlLabel
                  value="Compliance gate "
                  control={<Radio />}
                  label="Compliance gate "
                />
                <FormControlLabel
                  value="Delivery partner "
                  control={<Radio />}
                  label="Delivery partner "
                />
                <FormControlLabel
                  value="Business enabler"
                  control={<Radio />}
                  label="Business enabler"
                />
              </RadioGroup>
            </FormControl>
          </Grid>

          {/* QE influence on release decisions */}
          <Grid item xs={12}>
           <FormControl fullWidth variant="outlined">
              <InputLabel
                shrink
                id="qe-influence-label"
                sx={{
                  background: "#fff",
                  px: 0.5,
                  mb: 0.5,
                }}
              >
                How often does QE influence release decisions?
              </InputLabel>
              <Select
                labelId="qe-influence-label"
                value={qeInfluence}
                onChange={handleQeInfluenceChange}
                displayEmpty
                renderValue={(selected) => {
                  if (!selected) {
                    return <span style={{ color: "#aaa" }}>Select</span>;
                  }
                  return selected;
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200, // scroll if too many options
                      width: 300,     // fixed width
                    },
                  },
                  disablePortal: false,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  PopperProps: {
                    modifiers: [
                      {
                        name: "flip",
                        enabled: false,
                      },
                      {
                        name: "preventOverflow",
                        enabled: true,
                        options: {
                          boundary: "viewport",
                        },
                      },
                    ],
                  },
                }}
              >
                {qeInfluenceOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Quality metrics visible */}
          <Grid item xs={12}>
            <FormControl>
              <FormLabel>
                Are quality metrics visible in leadership dashboards or OKRs?
              </FormLabel>
              <RadioGroup
                row
                value={qualityMetrics}
                onChange={handleQualityMetricsChange}
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
                <FormControlLabel
                  value="Partially"
                  control={<Radio />}
                  label="Partially"
                />
              </RadioGroup>
            </FormControl>
          </Grid>
          {/* Quality failures */}
          <Grid item xs={12}>
            <FormControl>
              <FormLabel>
                Are quality failures reviewed across functional teams?
              </FormLabel>
              <RadioGroup
                row
                value={qualityFailures}
                onChange={handleQualityFailuresChange}
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
                <FormControlLabel
                  value="Partially"
                  control={<Radio />}
                  label="Partially"
                />
              </RadioGroup>
            </FormControl>
          </Grid>

          {/* Defect patterns */}
          <Grid item xs={12}>
           <FormControl fullWidth variant="outlined">
              <InputLabel
                shrink
                id="defect-patterns-label"
                sx={{
                  background: "#fff",
                  px: 0.5,
                  mb: 0.5,
                }}
              >
                Are defect patterns used to improve backlog or feature design?
              </InputLabel>
              <Select
                labelId="defect-patterns-label"
                value={defectPatterns}
                onChange={handleDefectPatternsChange}
                displayEmpty
                renderValue={(selected) => {
                  if (!selected) {
                    return <span style={{ color: "#aaa" }}>Select</span>;
                  }
                  return selected;
                }}
                MenuProps={{
                  PaperProps: {
                    style: {
                      maxHeight: 200, // scroll if too many options
                      width: 300,     // fixed width
                    },
                  },
                  disablePortal: false,
                  anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "left",
                  },
                  transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                  },
                  PopperProps: {
                    modifiers: [
                      {
                        name: "flip",
                        enabled: false,
                      },
                      {
                        name: "preventOverflow",
                        enabled: true,
                        options: {
                          boundary: "viewport",
                        },
                      },
                    ],
                  },
                }}
              >
                {defectPatternsOptions.map((option) => (
                  <MenuItem key={option} value={option}>
                    {option}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          {/* Production feedback */}
          <Grid item xs={12}>
            <FormControl>
              <FormLabel>
                Is production feedback mapped to automated tests?
              </FormLabel>
              <RadioGroup
                row
                value={prodFeedback}
                onChange={handleProdFeedbackChange}
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>

          {/* Percentage of automated tests */}
          <Grid item xs={12}>
          <FormControl fullWidth variant="outlined">
            <InputLabel
              shrink
              id="percentage-automated-tests-label"
              sx={{
                background: "#fff",
                px: 0.5,
                mb: 0.5,
              }}
            >
              What % of automated tests typically require rework per release?
            </InputLabel>
            <Select
              labelId="percentage-automated-tests-label"
              value={percentageOfAutomatedTests}
              onChange={handlePercentageOfAutomatedTestsChange}
              displayEmpty
              renderValue={(selected) => {
                if (!selected) {
                  return <span style={{ color: "#aaa" }}>Select</span>;
                }
                return selected;
              }}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 200, // scroll if too many options
                    width: 300,     // fixed width
                  },
                },
                disablePortal: false,
                anchorOrigin: {
                  vertical: "bottom",
                  horizontal: "left",
                },
                transformOrigin: {
                  vertical: "top",
                  horizontal: "left",
                },
                PopperProps: {
                  modifiers: [
                    {
                      name: "flip",
                      enabled: false,
                    },
                    {
                      name: "preventOverflow",
                      enabled: true,
                      options: {
                        boundary: "viewport",
                      },
                    },
                  ],
                },
              }}
            >
              {percentageOfAutomatedTestsOptions.map((option) => (
                <MenuItem key={option} value={option}>
                  {option}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          </Grid>

          {/* outdated or irrelevant */}
          <Grid item xs={12}>
            <FormControl>
              <FormLabel>
                Are outdated or irrelevant test scripts periodically retired?
              </FormLabel>
              <RadioGroup
                row
                value={feedbackLoops}
                onChange={handleFeedbackLoopsChange}
              >
                <FormControlLabel value="Yes" control={<Radio />} label="Yes" />
                <FormControlLabel value="No" control={<Radio />} label="No" />
              </RadioGroup>
            </FormControl>
          </Grid>
        </Grid>
      </Paper>

      {/* Buttons outside Paper */}
      <QEStrategyCommonButton handleBack={handleBack} handleNext={handleNext} />
    </Box>
  );
};

export default QualityCultureGovernanceAndTestDebt;
